import { combineEpics, Epic, ofType, StateObservable } from 'redux-observable';
import { delay, filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import { MapList, NODES_PER_MAP } from '../../Config/Levels';
import { Actions, ActionTypes, TAction } from '../Actions/Actions';
import { IGameState } from '../Store/store';
import { ItemIDs } from '../../Config/Items';

const startEpic: Epic<TAction, TAction, IGameState> = (
    action$,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.START_LEVEL),
        withLatestFrom(state$),
        mergeMap(([, state]) => {
            const actions: any[] = [];
            if (state.StateLevel.levelIndex <= 8 || state.StateLevel.levelIndex === 18) {
                actions.push(
                    Actions.silentStoreBooster([ItemIDs.HIGHLIGHT]),
                    Actions.addBoosters([ItemIDs.HIGHLIGHT])
                );
            }
            return actions;
        })
    );
};

const completeEpic: Epic<TAction, TAction, IGameState> = (
    action$,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.COMPLETE_LEVEL),
        withLatestFrom(state$),
        mergeMap(([, state]) => {
            const actions = [];
            // level score and level tiers
            if (state.StatePlayer.mapLevels[state.StateLevel.levelId]) {
                const endStr = state.StateLevel.levelId.substr(
                    state.StateLevel.levelId.indexOf('-') + 1
                );

                let score = state.StateScore.score;
                if (state.StateLevel.timed) {
                    // const firstTry = state.StateLevel.attempts === 0;
                    score = /*firstTry ?*/ state.StateScore.winTime /*: 0*/;
                }

                const stars = state.StateScore.tiers.filter(tier => tier <= score);
                const starsWon = Math.max(1, stars.length);

                actions.push(
                    Actions.updateMapData({ id: state.StateLevel.levelId, stars: starsWon })
                );

                const endNum = parseInt(endStr, 10);
                if (endNum < NODES_PER_MAP) {
                    actions.push(
                        Actions.unlockMapLevel(
                            state.StatePlayer.mapId + '-' + (endNum + 1).toString(10)
                        )
                    );
                    actions.push(Actions.transitionMap());
                } else {
                    // unlock new map
                    const next = MapList[MapList.indexOf(state.StatePlayer.mapId) + 1];

                    // do not add if next is null
                    // this check for was added in commit 0d21fef9 and removed in 3d4b5730
                    // ...probably merge error but should check better
                    if (next && !state.StatePlayer.unlocked.includes(next)) {
                        actions.push(Actions.unlockMap(next));
                    }

                    // dispatch event to show transition instead
                    // effect on state won't be save
                    // or it will, if prod. want to show transition on restart
                    actions.push(Actions.transitionMap());
                }
            }
            actions.push(Actions.levelComplete());

            return actions;
        })
    );
};

const startHintEpic: Epic<TAction, TAction, IGameState> = (
    action$,
    state$: StateObservable<IGameState>
) => {
    return action$.pipe(
        ofType(ActionTypes.START_LEVEL),
        withLatestFrom(state$),
        delay(100),
        filter(([_, state]) => state.StateLevel.levelIndex <= 2),
        mergeMap(() => {
            return [
                Actions.silentStoreBooster([ItemIDs.HINT]),
                Actions.addBoosters([ItemIDs.HINT]),
            ];
        })
    );
};

const levelEpic = combineEpics(startEpic, completeEpic, startHintEpic);

export default levelEpic;
